export const DAYS = [["mon", "Monday"], ["tue", "Tuesday"], ["wed", "Wednesday"], ["thu", "Thursday"], ["fri", "Friday"], ["sat", "Saturday"], ["sun", "Sunday"]];

const m = (s) => { const [h, mi] = String(s).split(":").map(Number); return h * 60 + mi; };

export const emptyWeek = () => Object.fromEntries(DAYS.map(([k]) => [k, { closed: true, periods: [] }]));

// Client-side mirror of the server rules (server remains authoritative).
export function periodError(p) {
  if (!p.open || !p.close) return "Enter opening and closing time";
  if (p.open === p.close) return "Opening and closing time cannot be the same";
  if (m(p.close) < m(p.open) && !p.overnight) return "Closes before it opens — tick Overnight if it ends after midnight";
  if (m(p.close) > m(p.open) && p.overnight) return "Overnight periods must close earlier than they open";
  return "";
}

export function dayError(d) {
  if (d.closed) return "";
  for (const p of d.periods) { const e = periodError(p); if (e) return e; }
  const spans = d.periods.map((p) => [m(p.open), m(p.close) + (p.overnight ? 1440 : 0)]).sort((a, b) => a[0] - b[0]);
  for (let i = 1; i < spans.length; i++) if (spans[i][0] < spans[i - 1][1]) return "Periods overlap";
  return "";
}

export function copyDay(week, from, targets) {
  const src = week[from];
  const out = { ...week };
  targets.forEach((k) => { out[k] = { closed: src.closed, periods: src.periods.map((p) => ({ ...p })) }; });
  return out;
}

export const fmtPeriods = (d) => (d.closed || !d.periods.length ? "Closed" : d.periods.map((p) => `${p.open}–${p.close}${p.overnight ? " (+1)" : ""}`).join(", "));
